"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertsSink = void 0;
const alert_1 = require("client/components/ui/alert");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./alerts.less");
let AlertsSink = class AlertsSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.alert = true;
    }
    render() {
        return (React.createElement("div", { className: "alerts" },
            React.createElement("h2", null, "Alerts"),
            React.createElement(alert_1.UiAlert, { title: "Error", message: "Email not found." }),
            this.alert && (React.createElement(alert_1.UiAlert, { dismissable: true, message: React.createElement("span", null,
                    "The file you uploaded is not recognized by our system. If you are not sure how to export the schedule from MacPractice, please",
                    " ",
                    React.createElement("a", { href: "#" }, "click here"),
                    "."), onRequestDismiss: () => {
                    this.alert = false;
                }, padded: true, title: "Unrecognized file" }))));
    }
};
__decorate([
    mobx_1.observable
], AlertsSink.prototype, "alert", void 0);
AlertsSink = __decorate([
    mobx_react_1.observer
], AlertsSink);
exports.AlertsSink = AlertsSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/alerts/alerts.tsx
// module id = 3610
// module chunks = 0